// extracted by mini-css-extract-plugin
module.exports = {"small":"nwea-ds-v1-template-small","medium":"nwea-ds-v1-template-medium","large":"nwea-ds-v1-template-large"};